import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[kui-input-group-btn]',
    standalone: false
})
export class KuiInputGroupBtnDirective {
  @HostBinding('class.input-group-btn') classBinding = true;
}
